import { gql } from '@apollo/client'

export const WIP_AI_CONVERSATION_FIELDS = gql`
  fragment WipAiConversationFields on WipAiConversation {
    id
    projectId
    month
    createdAt
    messages {
      id
      role
      content
      findings {
        id
        code
        severity
        title
        detail
        subjects {
          kind
          id
          label
        }
      }
      citations {
        path
        value
      }
      proposedChanges {
        oration
        budgetTrend
        keyDates {
          Name
          Description__c
          StartDate__c
          EndDate__c
          DateRange__c
          Project__c
        }
      }
      producedRevisionId
      producedRevLabel
      createdAt
    }
    revisions {
      id
      projectId
      month
      revisionNumber
      source
      caption
      createdAt
      parentRevisionId
      messageId
      snapshot {
        oration
        budgetTrend
        wipData {
          month
          budget
          wipPacing
          totalFeesAndExpenses
          submittedWriteOffs
          submittedHours {
            staffHours
            expertHours
            staffRate
            expertRate
          }
          submittedExpenses {
            staffExpenses
            expertExpenses
            writeOffs
          }
          hoursDetails {
            personName
            date
            comment
            hours
            total
          }
          expensesDetails {
            personName
            date
            description
            account
            cost
          }
          pacingWeek
          invoiceDiscount {
            isPercentage
            value
          }
        }
        keyDates {
          Name
          Description__c
          StartDate__c
          EndDate__c
          DateRange__c
          Project__c
        }
        findings {
          id
          code
          severity
          title
          detail
          subjects {
            kind
            id
            label
          }
        }
        contextUsed
      }
    }
  }
`

export const GET_WIP_AI_CONVERSATION = gql`
  query getWipAiConversation($projectId: String!, $month: String!) {
    getWipAiConversation(projectId: $projectId, month: $month) {
      ...WipAiConversationFields
    }
  }
  ${WIP_AI_CONVERSATION_FIELDS}
`

export const LIST_WIP_AI_CONVERSATIONS = gql`
  query listWipAiConversations($projectId: String!) {
    listWipAiConversations(projectId: $projectId) {
      ...WipAiConversationFields
    }
  }
  ${WIP_AI_CONVERSATION_FIELDS}
`

export const GENERATE_WIP_AI_REVISION = gql`
  mutation generateWipAiRevision($projectId: String!, $month: String!) {
    generateWipAiRevision(projectId: $projectId, month: $month) {
      ...WipAiConversationFields
    }
  }
  ${WIP_AI_CONVERSATION_FIELDS}
`

export const SEND_WIP_AI_MESSAGE = gql`
  mutation sendWipAiMessage($projectId: String!, $month: String!, $text: String!) {
    sendWipAiMessage(projectId: $projectId, month: $month, text: $text) {
      ...WipAiConversationFields
    }
  }
  ${WIP_AI_CONVERSATION_FIELDS}
`

export const SUBMIT_WIP_AI_REVISION = gql`
  mutation submitWipAiRevision($projectId: String!, $month: String!, $messageId: ID!) {
    submitWipAiRevision(projectId: $projectId, month: $month, messageId: $messageId) {
      ...WipAiConversationFields
    }
  }
  ${WIP_AI_CONVERSATION_FIELDS}
`

export const RESTORE_WIP_AI_REVISION = gql`
  mutation restoreWipAiRevision($revisionId: ID!) {
    restoreWipAiRevision(revisionId: $revisionId) {
      ...WipAiConversationFields
    }
  }
  ${WIP_AI_CONVERSATION_FIELDS}
`

export const DISCARD_WIP_AI_PROPOSAL = gql`
  mutation discardWipAiProposal($projectId: String!, $month: String!, $messageId: ID!) {
    discardWipAiProposal(projectId: $projectId, month: $month, messageId: $messageId) {
      ...WipAiConversationFields
    }
  }
  ${WIP_AI_CONVERSATION_FIELDS}
`

export const GET_WIP_AI_STAFF_UTILIZATION = gql`
  query getWipAiStaffUtilization($projectId: String!, $month: String!) {
    getWipAiStaffUtilization(projectId: $projectId, month: $month) {
      personId
      personName
      position
      hoursLogged
      entriesCount
      weeklyAssignedHours
      assignedHoursMonth
      utilizationPct
      resolvedHourlyRate
      fees
      rateSource
    }
  }
`
